import { render, staticRenderFns } from "./SalesOrderNew.vue?vue&type=template&id=f3906a54&scoped=true&"
import script from "./SalesOrderNew.vue?vue&type=script&lang=js&"
export * from "./SalesOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderNew.vue?vue&type=style&index=0&id=f3906a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3906a54",
  null
  
)

export default component.exports